import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Question16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_429)'>
      <path
        d='M8 12.5C8.55228 12.5 9 12.0523 9 11.5C9 10.9477 8.55228 10.5 8 10.5C7.44772 10.5 7 10.9477 7 11.5C7 12.0523 7.44772 12.5 8 12.5Z'
        fill='currentColor'
      />
      <path
        d='M6.75 6C6.75 5.30964 7.30964 4.75 8 4.75C8.69036 4.75 9.25 5.30964 9.25 6C9.25 6.47217 8.98849 6.88435 8.59884 7.09765C7.61295 7.63734 7.25 8.41623 7.25 9.5H8.75C8.75 8.94496 8.78854 8.70385 9.31911 8.41341C10.1702 7.94752 10.75 7.04201 10.75 6C10.75 4.48122 9.51878 3.25 8 3.25C6.48122 3.25 5.25 4.48122 5.25 6H6.75Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.25 8C0.25 3.71979 3.71979 0.25 8 0.25C12.2802 0.25 15.75 3.71979 15.75 8C15.75 12.2802 12.2802 15.75 8 15.75C3.71979 15.75 0.25 12.2802 0.25 8ZM8 1.75C4.54822 1.75 1.75 4.54822 1.75 8C1.75 11.4518 4.54822 14.25 8 14.25C11.4518 14.25 14.25 11.4518 14.25 8C14.25 4.54822 11.4518 1.75 8 1.75Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_429'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Question16.displayName = 'Question16';
export default Question16;
